module.exports = __webpack_public_path__ + "img/20200413142904TIM截图20200413142746.a635f8b9.png";